import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerSettings } from 'src/sb-tools/typescript/models/customer-settings.model';
import { environment } from '@environment';
import { PublicCustomer } from '@sb-tools/typescript/models/public-customer.model';

@Injectable({ providedIn: 'root' })
export class CustomerConfigurationService {
    constructor(private httpClient: HttpClient) {}

    get(): Observable<CustomerSettings> {
        return this.httpClient.get<CustomerSettings>(environment.apiMasterUrl + 'authorized/customerByCommunity/');
    }

    getOutboundEmailAddresses(): Observable<string[]> {
        return this.httpClient.get<string[]>(environment.apiInboxUrl + 'OutboundEmailAddresses/');
    }

    getPublicCustomer(): Observable<PublicCustomer> {
        return this.httpClient.get<PublicCustomer>(environment.apiMasterUrl + 'customer/');
    }
}
